import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import ModalVideo from 'react-modal-video';
import Breadcrumb from '../../components/Breadcrumb';
import SingleBlogThree from '../../components/Blog/SingleBlogThree';
import Button from '../../components/Button';
import Sidebar from '../../components/Blog/Sidebar';

import blogImg1 from '../../assets/img/blog/blog-sidebar-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-sidebar-2.jpg';
import blogImg3 from '../../assets/img/blog/blog-sidebar-3.jpg';
import blogImg4 from '../../assets/img/blog/blog-sidebar-4.jpg';
import blogImg7 from '../../assets/img/blog/blog-sidebar-7.jpg';

const BlogSidebarMain = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  const sliderOption = {
    speed: 1000,
    loop: true,
    slidesPerView: '1',
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
    },
    effect: 'fade',
    navigation: {
      prevEl: '.postbox-arrow-prev',
      nextEl: '.postbox-arrow-next',
    },
  };

  return (
    <main>
      <Breadcrumb title="Blog Sidebar" subTitle="Blog" />

      <div className="postbox-area pt-120 pb-120">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId="PO_fBTkoznc"
          onClose={() => openModal()}
        />
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-8">
              <div className="postbox-details-wrapper">
                <SingleBlogThree
                  blogImage={blogImg1}
                  authorName="Alrejaof"
                  publishedDate="Dec 28, 2022"
                  title="Preserving Care Strategy Amidst Food Changes"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris."
                />

                <SingleBlogThree
                  blogImage={blogImg2}
                  authorName="Alrejaof"
                  publishedDate="Dec 28, 2022"
                  title="Preserving Care Strategy Amidst Food Changes"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris."
                />

                <div className="postbox-thumb-box mb-80">
                  <div className="it-postbox-wrapper p-relative mb-30">
                    <div className="swiper-container postbox-thumb-slider-active">
                      <Swiper
                        modules={[Autoplay, EffectFade, Navigation]}
                        {...sliderOption}
                        className="swiper-wrapper"
                      >
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox-main-thumb">
                            <img src={blogImg2} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox-main-thumb">
                            <img src={blogImg3} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox-main-thumb">
                            <img src={blogImg7} alt="" />
                          </div>
                        </SwiperSlide>
                        <SwiperSlide className="swiper-slide">
                          <div className="postbox-main-thumb">
                            <img src={blogImg3} alt="" />
                          </div>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                    <div className="postbox-slider-arrow-wrap">
                      <button className="postbox-arrow-prev">
                        <i className="fa-solid fa-arrow-left"></i>
                      </button>
                      <button className="postbox-arrow-next">
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                  <div className="postbox-content-box">
                    <div className="postbox-meta mb-20">
                      <span>
                        <i className="flaticon-user-1"></i>Alrejaof
                      </span>
                      <span>
                        <i className="flaticon-clock"></i>Dec 28, 2022
                      </span>
                      <span>
                        <i className="flaticon-chat"></i>(04) Coments
                      </span>
                      <span>
                        <i className="flaticon-view"></i>1,526 views
                      </span>
                    </div>
                    <h4 className="postbox-title">
                      <a href="blog-details.html">
                        Preserving Care Strategy Amidst Food Changes
                      </a>
                    </h4>
                    <p className="mt-15 mb-30">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris.
                    </p>
                    <a className="it-btn-theme mr-30" href="blog-details.html">
                      <span className="btn-wrap">
                        <span className="text-one">View all items</span>
                        <span className="text-two">View all items</span>
                      </span>
                    </a>
                  </div>
                </div>

                <SingleBlogThree
                  blogImage={blogImg4}
                  authorName="Alrejaof"
                  publishedDate="Dec 28, 2022"
                  title="Preserving Care Strategy Amidst Food Changes"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris."
                />

                <SingleBlogThree
                  blogImage={blogImg3}
                  authorName="Alrejaof"
                  publishedDate="Dec 28, 2022"
                  title="Preserving Care Strategy Amidst Food Changes"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris."
                />

                <div className="postbox-thumb-box mb-80">
                  <div className="postbox-main-thumb p-relative mb-30">
                    <img src={blogImg1} alt="" />
                    <Link
                      className="it-choose-play pulse popup-video"
                      to="#"
                      onClick={openModal}
                    >
                      <i className="fa-sharp fa-solid fa-play"></i>
                    </Link>
                  </div>
                  <div className="postbox-content-box">
                    <div className="postbox-meta mb-20">
                      <span>
                        <i className="flaticon-user-1"></i>Alrejaof
                      </span>
                      <span>
                        <i className="flaticon-clock"></i>Dec 28, 2022
                      </span>
                      <span>
                        <i className="flaticon-chat"></i>(04) Coments
                      </span>
                      <span>
                        <i className="flaticon-view"></i>1,526 views
                      </span>
                    </div>
                    <h4 className="postbox-title">
                      <Link to="/blog-details">
                        Preserving Care Strategy Amidst Food Changes
                      </Link>
                    </h4>
                    <p className="mt-15 mb-30">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris.
                    </p>
                    <Link className="it-btn-theme mr-30" to="/blog-details">
                      <Button btnText="View all items" />
                    </Link>
                  </div>
                </div>

                <SingleBlogThree
                  itemClass="postbox-thumb-box"
                  blogImage={blogImg7}
                  authorName="Alrejaof"
                  publishedDate="Dec 28, 2022"
                  title="Preserving Care Strategy Amidst Food Changes"
                  description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris."
                />
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 order-lg-0 order-md-1">
              <Sidebar />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="it-pagination mt-50">
                <nav>
                  <ul>
                    <li>
                      <Link to="#">1</Link>
                    </li>
                    <li>
                      <Link to="#">2</Link>
                    </li>
                    <li>
                      <Link to="#">3</Link>
                    </li>
                    <li>
                      <Link className="color" to="#">
                        <i className="fa-solid fa-arrow-right-long"></i>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BlogSidebarMain;
